import { Link } from 'react-router-dom';
import { BACKEND_URL } from '../api/axios';

// --- Inline icon set (shared across all employer pages) ---
const BriefcaseNavIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);

const DatabaseNavIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
  </svg>
);

const UsersNavIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const BarChartNavIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <line x1="12" y1="20" x2="12" y2="10" />
    <line x1="18" y1="20" x2="18" y2="4" />
    <line x1="6" y1="20" x2="6" y2="16" />
  </svg>
);

const TeamNavIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <circle cx="9" cy="7" r="3" />
    <circle cx="17" cy="10" r="2.5" />
    <path d="M2.5 21a6.5 6.5 0 0 1 13 0" />
    <path d="M15 15.5a5.5 5.5 0 0 1 6.5 5.4" />
  </svg>
);

const BellNavIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const SlidersNavIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <line x1="4" y1="21" x2="4" y2="14" />
    <line x1="4" y1="10" x2="4" y2="3" />
    <line x1="12" y1="21" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12" y2="3" />
    <line x1="20" y1="21" x2="20" y2="16" />
    <line x1="20" y1="12" x2="20" y2="3" />
    <line x1="1" y1="14" x2="7" y2="14" />
    <line x1="9" y1="8" x2="15" y2="8" />
    <line x1="17" y1="16" x2="23" y2="16" />
  </svg>
);

const CreditCardNavIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const HelpNavIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const PhoneNavIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

export const ChevronDownIcon = ({ className = 'w-3.5 h-3.5' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

// Nav item: the active row is a filled purple-to-pink gradient pill
// (matching the matchmithra admin sidebar's highlighted item) instead of
// the previous flat green tint.
function SidebarNavItem({ icon, label, to, active, disabled, collapsed }) {
  const content = (
    <div
      className={`flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-semibold transition-colors ${
        active
          ? 'bg-gradient-to-r from-[#5B2EFF] via-[#8B5CF6] to-[#FF4D8D] text-white shadow-md shadow-purple-500/25'
          : disabled
          ? 'text-gray-300 cursor-not-allowed'
          : 'text-gray-600 hover:bg-purple-50'
      }`}
    >
      <span className="shrink-0">{icon}</span>
      <span
        className={`flex-1 whitespace-nowrap ${
          collapsed ? 'opacity-0 group-hover/sidebar:opacity-100 transition-opacity duration-150 delay-75' : ''
        }`}
      >
        {label}
      </span>
      {disabled && (
        <span
          className={`text-[10px] font-bold text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded whitespace-nowrap ${
            collapsed ? 'opacity-0 group-hover/sidebar:opacity-100 transition-opacity duration-150 delay-75' : ''
          }`}
        >
          Soon
        </span>
      )}
    </div>
  );

  if (disabled) return content;
  return <Link to={to}>{content}</Link>;
}

// Header block shown above the nav items: a purple-to-pink gradient
// banner with the company logo/initial and an "EMPLOYER" badge, styled
// after the matchmithra admin sidebar's brand header.
function SidebarHeader({ user, collapsed }) {
  return (
    <div className="bg-gradient-to-r from-[#5B2EFF] via-[#8B5CF6] to-[#FF4D8D] rounded-xl px-3 py-3 mb-2 flex items-center gap-2.5">
      {user?.company_logo ? (
        <img
          src={user.company_logo.startsWith('http') ? user.company_logo : `${BACKEND_URL}/storage/${user.company_logo}`}
          alt={user?.name}
          className="w-9 h-9 rounded-lg object-contain bg-white p-1 shrink-0"
        />
      ) : (
        <div className="w-9 h-9 rounded-lg bg-white/20 text-white font-bold flex items-center justify-center shrink-0 text-sm backdrop-blur-sm">
          {user?.company_name?.charAt(0)?.toUpperCase() || user?.name?.charAt(0)?.toUpperCase() || 'C'}
        </div>
      )}
      <div className={`flex-1 min-w-0 ${collapsed ? 'opacity-0 group-hover/sidebar:opacity-100 transition-opacity duration-150 delay-75' : ''}`}>
        <span className="block text-sm font-semibold text-white truncate whitespace-nowrap">
          {user?.company_name || user?.name || 'Your Company'}
        </span>
        <span className="inline-block mt-0.5 text-[10px] font-bold uppercase tracking-wide text-white/90 bg-white/20 rounded-full px-2 py-0.5 whitespace-nowrap">
          Employer
        </span>
      </div>
    </div>
  );
}

function EmployerSidebar({ user, activeTab, mobile = false, fixed = false }) {
  const renderItems = (collapsed) => (
    <>
      <SidebarNavItem icon={<BriefcaseNavIcon />} label="Jobs" to="/employer/jobs" active={activeTab === 'jobs'} collapsed={collapsed} />
     <SidebarNavItem icon={<DatabaseNavIcon />} label="Database" to="/employer/database" active={activeTab === 'database'} collapsed={collapsed} />
      <SidebarNavItem icon={<UsersNavIcon />} label="Candidate Pipeline" to="/employer/pipeline" active={activeTab === 'pipeline'} collapsed={collapsed} />
      <SidebarNavItem icon={<BarChartNavIcon />} label="Reports" to="/employer/reports" active={activeTab === 'reports'} collapsed={collapsed} />

      <div className="my-2 border-t border-gray-100" />
      <p className={`px-4 pt-1 pb-1 text-[11px] font-bold text-gray-400 uppercase tracking-wide whitespace-nowrap ${collapsed ? 'opacity-0 group-hover/sidebar:opacity-100 transition-opacity duration-150 delay-75' : ''}`}>
        Settings
      </p>
      <SidebarNavItem icon={<TeamNavIcon />} label="Team" to="/employer/team" active={activeTab === 'team'} collapsed={collapsed} />
      <SidebarNavItem icon={<BellNavIcon />} label="Notifications" to="/employer/settings/notifications" active={activeTab === 'notifications'} collapsed={collapsed} />
      <SidebarNavItem icon={<SlidersNavIcon />} label="Hiring Preferences" to="/employer/settings/hiring" active={activeTab === 'hiring'} collapsed={collapsed} />
      <SidebarNavItem icon={<CreditCardNavIcon />} label="Billing" to="/employer/settings/billing" active={activeTab === 'billing'} collapsed={collapsed} />

      <div className="my-2 border-t border-gray-100" />
      <SidebarNavItem icon={<HelpNavIcon />} label="Help & Support" to="/employer/helpsupport" active={activeTab === 'help&support'} collapsed={collapsed} />
      <SidebarNavItem icon={<PhoneNavIcon />} label="Contact Sales" disabled collapsed={collapsed} />
    </>
  );



  if (mobile) {
    return (
      <div className="lg:hidden bg-white rounded-xl shadow p-3 space-y-1 mb-4">
        <SidebarHeader user={user} collapsed={false} />
        {renderItems(false)}
      </div>
    );
  }

  if (fixed) {
    return (
      <div className="hidden lg:flex lg:flex-col w-64 bg-white border-r border-gray-100 fixed top-20 left-0 h-[calc(100vh-5rem)] overflow-y-auto p-3 space-y-1 z-30 shadow-sm">
        <SidebarHeader user={user} collapsed={false} />
        {renderItems(false)}
      </div>
    );
  }


  return (
    <div className="hidden lg:flex lg:flex-col group/sidebar peer w-16 hover:w-64 bg-white border-r border-gray-100 fixed top-20 left-0 h-[calc(100vh-5rem)] overflow-hidden hover:overflow-y-auto p-3 space-y-1 z-30 transition-all duration-200 ease-in-out shadow-sm hover:shadow-lg">
      <SidebarHeader user={user} collapsed={true} />
      {renderItems(true)}
    </div>
  );
}
export default EmployerSidebar;